import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { LogisticsSiteMethod } from '@lune-climate/lune/esm/client'
import { Table } from '@lune-fe/lune-ui-lib'
import { FC } from 'react'

import { getFormattedAmount } from '../../utils'

import { getShippingMethodLabel, getSourceOrDestination, isLogisticsSiteMethod, Leg } from './utils'

export const LegsPdfTable: FC<{ legs: Leg[] }> = ({ legs }) => {
    useLingui()

    const legFormattedAmount = (leg: Leg): string => {
        const formattedAmount = getFormattedAmount(leg.mass.amount)
        return `${formattedAmount.displayAmount} ${formattedAmount.amountUnit}CO₂e`
    }

    return (
        <Table.TableContainer data-testId={'cart-table'}>
            <Table
                sx={{
                    '.MuiTableCell-root > div': {
                        minHeight: '48px !important',
                    },
                }}
            >
                <Table.TableHead>
                    <Table.TableRow>
                        <Table.TableCell colSize={3}>{t`Leg`}</Table.TableCell>
                        <Table.TableCell colSize={6}>{t`Route`}</Table.TableCell>
                        <Table.TableCell colSize={3} alignEnd align="right">
                            {t`Emissions`}
                        </Table.TableCell>
                    </Table.TableRow>
                </Table.TableHead>
                <Table.TableBody>
                    {legs.map((leg, index) => {
                        const sourceLabel = leg.routeInferenceDetails?.route.source.label
                        const destinationLabel = leg.routeInferenceDetails?.route.destination.label
                        // used to show the logistics site
                        const shippingMethodLabel = isLogisticsSiteMethod(leg.method)
                            ? getShippingMethodLabel(leg.method as LogisticsSiteMethod)
                            : undefined

                        const inferredRoute = leg.routeInferenceDetails
                            ? {
                                  source: leg.routeInferenceDetails.route.source.coordinates,
                                  destination:
                                      leg.routeInferenceDetails.route.destination.coordinates,
                              }
                            : null

                        return (
                            <Table.TableRow key={`leg-${index}`}>
                                <Table.TableCell colSize={3}>{t`Leg ${index + 1}`}</Table.TableCell>
                                <Table.TableCell colSize={6}>
                                    {leg.route ? (
                                        <>
                                            {'amount' in leg.route ? (
                                                <>
                                                    {' '}
                                                    {leg.route.amount} {leg.route.unit}
                                                </>
                                            ) : (
                                                <>
                                                    {
                                                        getSourceOrDestination(
                                                            sourceLabel ??
                                                                inferredRoute?.source ??
                                                                leg.inferenceDetails?.cleanedRoute
                                                                    ?.source ??
                                                                leg.route.source,
                                                            '',
                                                        ).label as string
                                                    }
                                                    {
                                                        getSourceOrDestination(
                                                            destinationLabel ??
                                                                inferredRoute?.destination ??
                                                                leg.inferenceDetails?.cleanedRoute
                                                                    ?.destination ??
                                                                leg.route.destination,
                                                            `${' '}${t`to`}`,
                                                        ).label as string
                                                    }
                                                </>
                                            )}
                                        </>
                                    ) : shippingMethodLabel ? (
                                        <>{shippingMethodLabel}</>
                                    ) : (
                                        <></>
                                    )}
                                </Table.TableCell>
                                <Table.TableCell colSize={3} alignEnd align="right">
                                    {legFormattedAmount(leg)}
                                </Table.TableCell>
                            </Table.TableRow>
                        )
                    })}
                </Table.TableBody>
            </Table>
        </Table.TableContainer>
    )
}
